import { forwardRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@rtkwlf/pro-solid-svg-icons/faCalendarAlt';

import type { MultiInputDateTimeRangeFieldProps } from '..';
import type { RangePosition } from '../..';
import { FormControlWrapper } from '../../../form-control-wrapper';
import { InputAdornment } from '../../../input-adornment';
import { OutlinedInput } from '../../../outlined-input';
import type { TextFieldProps } from '../../../text-field';
import { getDateInputFieldProps } from '../../utils/get-date-input-field-props';

// Props passed to textfield slot is based off TextFieldProps
type DateTimeRangeInputFieldProps = TextFieldProps & {
  ownerState: MultiInputDateTimeRangeFieldProps & {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    ownerState?: any; // DateTimeRangePicker ownerState (mobile or desktop)
    position: RangePosition;
  };
};

export const DateTimeRangeInputField = forwardRef<
  HTMLDivElement,
  DateTimeRangeInputFieldProps
>((props: DateTimeRangeInputFieldProps, ref) => {
  const { isFieldOnly, formControlWrapperProps, outlinedInputProps } =
    getDateInputFieldProps(props);

  const {
    className,
    FormHelperTextProps,
    InputLabelProps,
    size,
    ...otherFormControlWrapperProps
  } = formControlWrapperProps;

  const formControlClasses = `${className ?? ''} ${otherFormControlWrapperProps.label ? 'MuiFormControl-hasLabel' : ''} ${size === 'medium' ? 'MuiFormControl-mediumInputSize' : 'MuiFormControl-defaultInputSize'}`;

  return (
    <FormControlWrapper
      ref={ref}
      className={formControlClasses}
      formHelperTextProps={FormHelperTextProps}
      formLabelProps={InputLabelProps}
      {...otherFormControlWrapperProps}
    >
      <OutlinedInput
        endAdornment={
          !isFieldOnly && (
            <InputAdornment
              position="end"
              sx={{
                '.svg-inline--fa': {
                  padding: 0,
                },
              }}
            >
              <FontAwesomeIcon
                aria-hidden
                icon={faCalendarAlt}
                title="calendar-icon"
              />
            </InputAdornment>
          )
        }
        sx={{
          input: {
            minWidth: '180px',
          },
        }}
        {...outlinedInputProps}
      />
    </FormControlWrapper>
  );
});
